<template>
  <div
    class="modal fade contacts-modal"
    id="contactsModal"
    tabindex="-1"
    aria-labelledby="contactsModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label"
              >Вы можете связаться с продавцом самостоятельно, контакты есть в
              карточке товара или в мессенджере.</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "ContactsModal",
});
</script>

<style scoped lang="scss">
.form-label {
  display: flex;
  justify-content: center;
}
</style>
